(function () {
  'use strict';

  function init() {
    initVideoAutoplay();

    initAccordions();

    initTabs();

    initCardScrollers();

    initScrollToTop();

    if (typeof gsap !== 'undefined') {
      initGSAPAnimations();
    } else {
      console.warn('GSAP not loaded - animations disabled');
    }
  }

  function initVideoAutoplay() {
    const videos = document.querySelectorAll('video');
    videos.forEach(function (video) {
      video.play().catch(function (error) {});
    });
  }

  function initAccordions() {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function () {
        const isActive = this.classList.contains('active');

        this.classList.toggle('active');

        const panel = this.nextElementSibling;

        if (panel && panel.classList.contains('accordion_inner')) {
          if (isActive) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });
    });
  }

  function initTabs() {
    const tabLinks = document.querySelectorAll('.tab_link');
    const tabContents = document.querySelectorAll('.tab_content');

    tabContents.forEach(function (content, index) {
      if (index === 0) {
        content.style.display = 'flex';
      } else {
        content.style.display = 'none';
      }
    });

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const tabId = this.getAttribute('tab');

        if (!tabId) return;

        tabLinks.forEach(function (tab) {
          tab.classList.remove('active');
        });

        tabLinks.forEach(function (tab) {
          if (tab.getAttribute('tab') === tabId) {
            tab.classList.add('active');
          }
        });

        tabContents.forEach(function (content) {
          content.style.display = 'none';
        });

        const targetContent = document.getElementById(tabId);
        if (targetContent) {
          targetContent.style.display = 'flex';

          if (e.isTrusted) {
            const tabsSection = document.querySelector('.tabs_section');
            if (tabsSection) {
              const offset = 100;
              const elementPosition = tabsSection.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              });
            }
          }
        }
      });
    });

    const defaultTab = document.getElementById('defaultOpen');
    if (defaultTab && !defaultTab.classList.contains('active')) {
      defaultTab.classList.add('active');
    }
  }

  function initCardScrollers() {
    const principiCardsWrapper = document.querySelector('.principi_cards_wrapper');
    const principiCards = document.querySelectorAll('.principi_card');
    const principiBullets = document.querySelectorAll('.section_scelta .bullet');

    if (principiCards.length > 0 && principiBullets.length > 0) {
      setupCardScroller(principiCardsWrapper, principiCards, principiBullets);
    }

    const animationCardsWrapper = document.querySelector('.animation_cards_wrapper');
    const animationCards = document.querySelectorAll('.animation_card');
    const animationBullets = document.querySelectorAll('.section_card_animated .bullet');

    if (animationCards.length > 0 && animationBullets.length > 0) {
      setupCardScroller(animationCardsWrapper, animationCards, animationBullets);
    }
  }

  function setupCardScroller(wrapper, cards, bullets) {
    if (!wrapper || cards.length === 0 || bullets.length === 0) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const index = Array.from(cards).indexOf(entry.target);
            updateActiveBullet(bullets, index);
          }
        });
      },
      {
        root: wrapper,
        threshold: 0.5,
      },
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });

    bullets.forEach(function (bullet, index) {
      bullet.addEventListener('click', function () {
        const targetCard = cards[index];
        if (targetCard) {
          targetCard.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
          updateActiveBullet(bullets, index);
        }
      });
    });
  }

  function updateActiveBullet(bullets, activeIndex) {
    bullets.forEach(function (bullet, index) {
      if (index === activeIndex) {
        bullet.classList.add('active');
      } else {
        bullet.classList.remove('active');
      }
    });
  }

  function initScrollToTop() {
    const scrollButtons = document.querySelectorAll('.scroll_up_btn');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    });
  }

  function initGSAPAnimations() {
    try {
      if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
      }
      if (typeof ScrollToPlugin !== 'undefined') {
        gsap.registerPlugin(ScrollToPlugin);
      }

      const animationCards = document.querySelectorAll('.animation_card');
      if (animationCards.length > 0) {
        gsap.fromTo(
          animationCards,
          { y: 50, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 0.8,
            scrollTrigger: {
              trigger: '.section_card_animated',
              start: 'top 80%',
              toggleActions: 'play none none none',
              once: true,
            },
          },
        );
      }

      const fadeElements = document.querySelectorAll('[fade]');
      fadeElements.forEach(function (el) {
        gsap.fromTo(
          el,
          { autoAlpha: 0, y: 50 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              toggleActions: 'play none none none',
              once: true,
            },
          },
        );
      });
    } catch (error) {
      console.warn('GSAP initialization error:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
